import React from 'react'
import Body from './Body';
import Footer from './Footer';
import './Player.css'
import Sidebar from './Sidebar';

const Player = ({ spotify }) => {
    console.log("spotify", spotify);
    return (
        <div className="player">
            <div className="player__body">
                <Sidebar />
                <Body spotify={spotify} />
            </div>
            <Footer spotify={spotify} />
        </div>

    )
}

export default Player